import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { AccessibilityBrowserZoom } from './accessibilityBrowserZoom'

export { name } from './symbols'
export type { AccessibilityBrowserZoomPageConfig } from './types'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageDidMountHandler, LifeCycle.PageDidUnmountHandler).to(AccessibilityBrowserZoom)
}
